module.exports = __webpack_public_path__ + "img/hz3.005c6964.png";